import API from 'api/api';

export const getPublicSettings = async () => {
  const response = await API.get('/settings/public');
  return response.data;
};

export const updateSettings = async (payload) => {
  const response = await API.put('/settings', payload);
  return response.data;
};

export const getAiUsers = async () => {
  const response = await API.get('/settings/ai-users');
  return response.data;
};

export const getPaymentDelayedUsers = async () => {
  const response = await API.get('/settings/payment-delayed-users');
  return response.data;
};

export const searchUsers = async (query) => {
  const response = await API.get('/settings/search-users', { params: { q: query } });
  return response.data;
};

export const bulkSetAiStatus = async (aiEnabled) => {
  const response = await API.put('/settings/ai-bulk', { aiEnabled });
  return response.data;
};
